import React, { useState, useEffect } from "react";
import ReactApexChart from 'react-apexcharts';

const RadialBarChart = (props) => {
    const { selectedYear } = props;

    const [trainingInformation, setTrainingInformation] = useState({});

    const [planningCount, setPlanningCount] = useState(0);
    const [radialBarChartValues, setRadialBarChartValues] = useState({
        series:[planningCount, 0, 0],
        labels: ["Planning", "Forecast", "Actuals"]
    })

    useEffect(() => {
        if (selectedYear) {
            const plannedEvents = localStorage.getItem("plannedEvent");
            setTrainingInformation(JSON.parse(plannedEvents));
        }
    }, [selectedYear]);

    useEffect(() => {
        if(trainingInformation){
            const count = Object.keys(trainingInformation[selectedYear] || {}).length;
            setPlanningCount(count);
            setRadialBarChartValues(prevValues => ({
                ...prevValues,
                series: [count, 0, 0]
            }));
        }
    },[trainingInformation, selectedYear])

    console.log(trainingInformation);

    const doughnutOptions = {
        series: radialBarChartValues.series,
        // fill: {
        colors: ['#7037B8', '#F4BC38', '#2D9CDB'],
        // },
        chart: {
            height: 400,
            width: 400,
            type: 'radialBar',
        },
        legend: {
            show: true,
            // floating:true,
            horizontalAlign: 'center',
            position: 'right',
            formatter: function (seriesName, opts) {
                return [opts.w.config.labels[opts.seriesIndex], '(' + opts.w.config.series[opts.seriesIndex] + ')']
            },
            labels: {
                colors: '#fff',
            },
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    margin: 7,
                    size: "30%",
                },
                track: {
                    background: '#42414169',
                    width: 400,
                    margin: 10,
                },
                dataLabels: {
                    name: {
                        fontSize: '12px',
                    },
                    value: {
                        fontSize: '12px',
                        color: '#7037B8',
                        formatter: function (val) {
                            return val
                        }
                    },
                    total: {
                        show: true,
                        fontSize: '12px',
                        label: 'Planning',
                        color: '#7037B8',
                        formatter: function (w) {
                            return w.globals.initialConfig.series[0]
                        },
                    },
                },
                colors: ['#7037B8', '#F4BC38', '#2D9CDB']
            },
        },
        labels: radialBarChartValues.labels,
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    };
    return (
        <>
            <ReactApexChart options={doughnutOptions} series={doughnutOptions.series} type="radialBar" height={400} width={400} />
        </>
    )
}

export default RadialBarChart;